import { searchResults as TYPES } from './../action_types';
import * as Services from './services';

export function followUser(userId, callback) {
  return function (dispatch) {
    Services.FollowUserService(userId, 'POST').then(() =>
      dispatch({
        type: TYPES.FOLLOW_USER_SUCCESS,
        followeeId: userId,
      }),
    );

    callback();
  };
}

export function unfollowUser(userId, callback) {
  return function (dispatch) {
    Services.FollowUserService(userId, 'DELETE').then(() =>
      dispatch({
        type: TYPES.UNFOLLOW_USER_SUCCESS,
        unfolloweeId: userId,
      }),
    );

    callback();
  };
}

export function followResearchInterest(interest, callback) {
  return function (dispatch) {
    Services.FollowInterestService(interest.id).then(() =>
      dispatch({
        type: TYPES.FOLLOW_RI_SUCCESS,
        interest: interest,
      }),
    );

    callback();
  };
}

export function unfollowResearchInterest(interest, callback) {
  return function (dispatch) {
    Services.UnfollowInterestService(interest.id).then(() =>
      dispatch({
        type: TYPES.UNFOLLOW_RI_SUCCESS,
        interest: interest,
      }),
    );

    callback();
  };
}

// load # papers, then # views, then # followers
export function fetchActorData(actor) {
  return function (dispatch) {
    const onFetchWorkCountSuccess = (data) => {
      dispatch({
        type: TYPES.FETCH_ACTOR_DATA_SUCCESS,
        actor: actor,
        workCount: data.count,
      });

      Services.UserViewCountService({ user_id: actor.id }).then(
        onFetchViewCountSuccess,
      );
    };

    const onFetchViewCountSuccess = (data) => {
      dispatch({
        type: TYPES.FETCH_ACTOR_DATA_SUCCESS,
        actor: actor,
        viewCount: data.all_time_stats.documents_count,
      });

      Services.UserFollowerCountService({ user_id: actor.id }).then((data) =>
        dispatch({
          type: TYPES.FETCH_ACTOR_DATA_SUCCESS,
          actor: actor,
          followerCount: data.meta.count,
        }),
      );
    };

    Services.UserWorkCountService({ user_id: actor.id }).then(
      onFetchWorkCountSuccess,
    );
  };
}

export function fetchResearchInterestFollowerCount(interest) {
  return function (dispatch) {
    const onResearchInterestFollowerCountSuccess = (data) => {
      dispatch({
        type: TYPES.FETCH_RI_FOLLOWER_COUNT_SUCCESS,
        interest: interest,
        followerCount: data.count,
      });
    };

    Services.ResearchInterestFollowerCountService({
      interest_id: interest.id,
    }).then(onResearchInterestFollowerCountSuccess);
  };
}

export function addToLibrary(workId, source = 'search-results', callback) {
  return function (dispatch) {
    const onAddToLibrarySuccess = () => {
      const indexedWorks = {};
      indexedWorks[workId] = { isBookmarked: true };

      dispatch({
        type: TYPES.UPDATE_WORKS,
        works: indexedWorks,
      });

      callback();
    };

    Services.AddToLibraryService(workId, source).then(onAddToLibrarySuccess);
  };
}

export function removeFromLibrary(workId, callback) {
  return function (dispatch) {
    const onRemoveFromLibrarySuccess = () => {
      const indexedWorks = {};
      indexedWorks[workId] = { isBookmarked: false };

      dispatch({
        type: TYPES.UPDATE_WORKS,
        works: indexedWorks,
      });

      callback();
    };

    Services.RemoveFromLibraryService(workId).then(onRemoveFromLibrarySuccess);
  };
}

export function requestJoinSession(invitationToken, callback) {
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return function (dispatch) {
    const onRequestJoinSessionSuccess = (data) => {
      callback(data.invitation_status);
    };

    Services.JoinDiscussionService(invitationToken).then(
      onRequestJoinSessionSuccess,
    );
  };
}

// reportWork both creates a RelatedWorkRejection and delivers the survey results
// RelatedWorkRejection has 2 category enums -- personal (related to user's tastes) and general (spam)
export function reportWork(choices, workId, category) {
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return function (dispatch) {
    Services.RejectRelatedWorkService(workId, category);

    Services.SurveyReponseService(choices);
  };
}

export function loadWorkShareSuggestions(workId) {
  return function (dispatch) {
    Services.WorkShareSuggestionService(workId).then((data) => {
      const indexedWorks = {};
      indexedWorks[workId] = {
        shareSuggestions: data.suggestions,
        alreadySharedUserIds: data.already_shared_user_ids,
      };

      dispatch({
        type: TYPES.UPDATE_WORKS,
        works: indexedWorks,
      });
    });
  };
}
